/* ToyBox Shipping Protection. Optional cart enhancement; native checkout stays available. */
(function () {
  'use strict';
  const CHOICE_ATTRIBUTE = 'toybox_shipping_protection';
  const LEGACY_PRODUCT_IDS = ["11297333674311","9744821322055","9744821092679"];
  function planProtection(cart, config, requestedChoice) {
    const lines = (cart.items || []).filter((item) => String(item.variant_id || item.id) === String(config.variantId));
    const legacy = (cart.items || []).filter((item) => LEGACY_PRODUCT_IDS.includes(String(item.product_id)));
    const eligible = (cart.items || []).some((item) => item.requires_shipping && !LEGACY_PRODUCT_IDS.includes(String(item.product_id)) && String(item.variant_id || item.id) !== String(config.variantId));
    const stored = (cart.attributes || {})[CHOICE_ATTRIBUTE];
    const preference = typeof requestedChoice === 'boolean' ? requestedChoice : stored === 'off' ? false : stored === 'on' ? true : config.defaultEnabled;
    const wanted = eligible && preference && config.available;
    const updates = {};
    legacy.forEach((line) => { if (line.quantity > 0) updates[line.key] = 0; });
    lines.forEach((line, index) => {
      const quantity = wanted && index === 0 ? 1 : 0;
      if (line.quantity !== quantity) updates[line.key] = quantity;
    });
    return { eligible, selected: lines.concat(legacy).some((line) => line.quantity > 0), preference, updates, add: wanted && lines.length === 0,
      attribute: typeof requestedChoice === 'boolean' && stored !== (requestedChoice ? 'on' : 'off') ? (requestedChoice ? 'on' : 'off') : null };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { planProtection, CHOICE_ATTRIBUTE };
  if (typeof window === 'undefined' || !window.customElements || customElements.get('toybox-shipping-protection')) return;
  class ProtectionController {
    constructor() {
      this.elements = new Set(); this.cart = null; this.config = null; this.running = false; this.pending = false;
      this.refreshRequested = false; this.freshMarkup = false; this.choice = null; this.displayChoice = null; this.error = false;
      this.blocked = false; this.suspendAutomatic = false; this.restoreRequested = false; this.checkoutChoice = null; this.navigating = false; this.requestTimeout = 6000; this.requests = new Set(); this.timer = null;
      // Native checkout is never cancelled or disabled by this optional module.
      document.addEventListener('submit', (event) => {
        if (event.submitter && event.submitter.name === 'checkout') {
          this.navigating = true;
          this.requests.forEach((request) => request.abort());
        }
      }, true);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event && event.source === 'toybox-shipping-protection') return;
          this.schedule(true);
        });
      }
      window.addEventListener('pageshow', (event) => { if (!event.persisted) return; this.navigating = false; this.restoreRequested = true; this.schedule(true); });
      window.addEventListener('online', () => { if (!this.error || this.navigating) return; this.restoreRequested = true; this.schedule(true); });
    }
    connect(element) {
      this.elements.add(element);
      this.config = { variantId: element.dataset.variantId, available: element.dataset.available === 'true', defaultEnabled: element.dataset.defaultEnabled !== 'false' };
      try {
        const json = element.querySelector('[data-protection-cart]');
        if (json) {
          const cart = JSON.parse(json.textContent);
          if (Array.isArray(cart.items)) {
            const before = this.cart && planProtection(this.cart, this.config);
            const after = planProtection(cart, this.config);
            if (!this.running && before && before.selected && !after.selected && after.eligible) this.choice = false;
            this.cart = cart; this.freshMarkup = true;
          }
        }
      } catch (_) { this.refreshRequested = true; }
      this.paint(); this.schedule(!this.cart);
    }
    disconnect(element) { this.elements.delete(element); }
    schedule(refresh) {
      this.pending = true; this.refreshRequested = this.refreshRequested || !!refresh;
      if (this.running || this.timer !== null) return;
      this.timer = setTimeout(() => { this.timer = null; this.flush(); }, 0);
    }
    select() {
      if (this.running || this.displayChoice !== null || !this.cart || !this.config) return;
      this.choice = !planProtection(this.cart, this.config).selected;
      this.checkoutChoice = this.choice; this.syncCheckoutChoice();
      this.displayChoice = this.choice;
      const needsRefresh = this.error || this.blocked;
      if (needsRefresh) this.freshMarkup = false;
      this.suspendAutomatic = false;
      this.error = false;
      this.paint();
      this.schedule(needsRefresh);
    }
    route(path) {
      const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
      return root.replace(/\/?$/, '/') + path;
    }
    async json(url, options) {
      const abort = new AbortController(); this.requests.add(abort); let timer;
      try {
        const deadline = new Promise((_, reject) => { timer = setTimeout(() => { abort.abort(); reject(new Error('Cart request timed out')); }, this.requestTimeout); });
        return await Promise.race([deadline, (async () => {
          const response = await fetch(url, Object.assign({ credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } }, options, { signal: abort.signal }));
          const result = await response.json();
          if (!response.ok || !result || result.errors || result.status && Number(result.status) >= 400) throw new Error('Cart request failed');
          return result;
        })()]);
      } finally { clearTimeout(timer); this.requests.delete(abort); }
    }
    readCart() { return this.json(this.route('cart.js')); }
    sectionTargets() {
      const targets = [{ id: 'CartDrawer', section: 'cart-drawer', selector: '#CartDrawer' }, { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }];
      const pageCart = document.querySelector('cart-items');
      if (pageCart && typeof pageCart.getSectionsToRender === 'function') {
        pageCart.getSectionsToRender().forEach((target) => { if (!targets.some((existing) => existing.section === target.section)) targets.push(target); });
      }
      return targets.filter((target) => target.section && document.getElementById(target.id)).slice(0, 5);
    }
    async mutate(endpoint, data, targets) {
      return this.json(this.route('cart/' + endpoint + '.js'), {
        method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(Object.assign({}, data, { sections: targets.map((target) => target.section), sections_url: window.location.pathname })),
      });
    }
    updateFor(plan) {
      const updates = Object.assign({}, plan.updates);
      if (plan.add) updates[this.config.variantId] = 1;
      const update = {};
      if (Object.keys(updates).length) update.updates = updates;
      if (plan.attribute !== null) update.attributes = { [CHOICE_ATTRIBUTE]: plan.attribute };
      return update;
    }
    async fetchSections(targets) {
      const url = new URL(window.location.pathname, window.location.origin);
      url.searchParams.set('sections', targets.map((target) => target.section).join(','));
      return this.json(url.pathname + url.search, { headers: { Accept: '*/*' } });
    }
    async render(cart, sections, targets) {
      if (this.navigating) return;
      this.cart = cart;
      const valid = (value) => targets.every((target) => value && typeof value[target.section] === 'string' && value[target.section].trim());
      if (!valid(sections)) sections = await this.fetchSections(targets);
      if (this.navigating) return;
      if (!valid(sections)) throw new Error('Cart sections could not render');
      const replacements = targets.map((target) => {
        const html = new DOMParser().parseFromString(sections[target.section], 'text/html');
        const source = html.querySelector(target.selector || '.shopify-section');
        const container = target.id === 'main-cart-footer' ? document.querySelector('#main-cart-footer[data-id]') : document.getElementById(target.id);
        const destination = target.id === 'CartDrawer' || target.id === 'cart-icon-bubble' ? container : container && (container.querySelector(target.selector) || container);
        if (!source || !destination) throw new Error('Cart section target is missing');
        return { target, source, destination };
      });
      const drawer = document.querySelector('cart-drawer');
      const open = !!(drawer && drawer.classList.contains('active'));
      const focusToggle = !!(document.activeElement && document.activeElement.closest('toybox-shipping-protection'));
      if (drawer) drawer.classList.toggle('is-empty', cart.item_count === 0);
      const nativeRender = open && drawer && typeof drawer.renderContents === 'function';
      if (nativeRender) drawer.renderContents(Object.assign({}, cart, { sections }));
      replacements.forEach(({ target, source, destination }) => {
        if (nativeRender && (target.id === 'CartDrawer' || target.id === 'cart-icon-bubble')) return;
        destination.innerHTML = source.innerHTML;
      });
      if (drawer && !nativeRender) {
        const overlay = drawer.querySelector('#CartDrawer-Overlay');
        if (overlay && typeof drawer.close === 'function') overlay.addEventListener('click', drawer.close.bind(drawer));
      }
      const footer = document.querySelector('#main-cart-footer[data-id]');
      if (footer) footer.classList.toggle('is-empty', cart.item_count === 0);
      this.blocked = false; this.paint();
      if (open && focusToggle) setTimeout(() => {
        const toggle = document.querySelector('toybox-shipping-protection [data-protection-toggle]');
        if (toggle) toggle.focus({ preventScroll: true });
      }, 0);
    }
    async flush() {
      if (this.navigating || this.running || !this.pending || !this.config || !this.config.variantId) return;
      this.pending = false;
      let requestedChoice = this.choice === null && this.error ? this.checkoutChoice : this.choice; this.choice = null;
      const restoring = this.restoreRequested; this.restoreRequested = false;
      if (restoring) this.suspendAutomatic = false;
      const shouldRead = restoring || !this.cart || this.blocked || this.refreshRequested && !this.freshMarkup;
      this.refreshRequested = false; this.freshMarkup = false;
      if (this.suspendAutomatic && typeof requestedChoice !== 'boolean') { this.paint(); return; }
      this.running = true; let targets = []; let changed = false;
      try {
        this.paint(); targets = this.sectionTargets();
        if (shouldRead) {
          const before = this.cart && planProtection(this.cart, this.config);
          this.cart = await this.readCart();
          const after = planProtection(this.cart, this.config);
          if (typeof requestedChoice !== 'boolean' && before && before.selected && !after.selected && after.eligible) {
            requestedChoice = false; this.checkoutChoice = false; this.syncCheckoutChoice();
          }
        }
        let sections = null;
        for (let attempt = 0; attempt < 2; attempt += 1) {
          if (this.navigating) return;
          const plan = planProtection(this.cart, this.config, requestedChoice);
          const update = this.updateFor(plan);
          if (!Object.keys(update).length) break;
          this.displayChoice = plan.eligible && plan.preference && this.config.available; this.paint();
          this.cart = await this.mutate('update', update, targets);
          sections = this.cart.sections;
          changed = true;
        }
        const remaining = this.updateFor(planProtection(this.cart, this.config, requestedChoice));
        if (Object.keys(remaining).length) throw new Error('Cart changed while saving shipping protection');
        if (changed || shouldRead || this.blocked) await this.render(this.cart, sections, targets);
        this.error = false; this.suspendAutomatic = false;
      } catch (_) {
        this.error = true; this.suspendAutomatic = true;
        if (this.navigating) return;
        try {
          const actual = await this.readCart(); await this.render(actual, null, targets);
          const recovered = planProtection(actual, this.config, requestedChoice);
          this.blocked = Object.keys(recovered.updates).length > 0;
          if (!recovered.add && !Object.keys(recovered.updates).length && recovered.attribute === null) { this.error = false; this.suspendAutomatic = false; }
        } catch (_) { this.blocked = true; }
      } finally {
        this.displayChoice = null; this.running = false;
        try { this.paint(); } catch (_) { /* Widget errors cannot affect native checkout. */ }
        if (this.pending && (!this.suspendAutomatic || this.restoreRequested)) this.schedule(false);
      }
    }
    syncCheckoutChoice() {
      if (this.navigating || this.checkoutChoice === null) return;
      this.elements.forEach((element) => {
        element.querySelectorAll('[data-protection-native-off]').forEach((input) => { input.disabled = this.checkoutChoice !== false; });
      });
    }
    paint() {
      if (this.navigating) return;
      this.syncCheckoutChoice();
      const state = this.cart && this.config ? planProtection(this.cart, this.config) : null;
      const busy = this.running || this.displayChoice !== null;
      this.elements.forEach((element) => {
        if (!element.isConnected) return;
        const toggle = element.querySelector('[data-protection-toggle]');
        const copy = element.querySelector('[data-protection-copy]');
        const error = element.querySelector('[data-protection-error]');
        const actualSelected = !!(state && state.selected);
        const selected = this.displayChoice === null ? actualSelected : this.displayChoice;
        element.hidden = !!(state && !state.eligible && !actualSelected && !this.error);
        element.dataset.selected = String(selected);
        element.dataset.busy = String(busy);
        element.setAttribute('aria-busy', String(busy));
        if (toggle) {
          toggle.setAttribute('aria-checked', String(selected));
          toggle.disabled = busy || !state || (!state.eligible && !actualSelected) || (!this.config.available && !actualSelected);
        }
        if (copy) copy.textContent = !this.config.available && !selected ? element.dataset.unavailableMessage : selected ? element.dataset.activeMessage : element.dataset.inactiveMessage;
        if (error) { error.hidden = !this.error; error.textContent = this.error ? element.dataset.errorMessage : ''; }
      });

    }

  }
  const controller = new ProtectionController();
  customElements.define('toybox-shipping-protection', class extends HTMLElement {
    connectedCallback() {
      this.clickHandler = (event) => { if (event.target.closest('[data-protection-toggle]')) { event.preventDefault(); controller.select(); } };
      this.addEventListener('click', this.clickHandler); controller.connect(this);
    }
    disconnectedCallback() { this.removeEventListener('click', this.clickHandler); controller.disconnect(this); }
  });
})();
